import http from './http';

export const adminHealth = (config = {}) => http.get('/admin/health', config);
export const fetchAdminMetrics = (params = {}) => http.get('/admin/metrics', { params });
export const fetchAdminGiftFeedsMonitoring = () => http.get('/admin/gift-feeds/monitoring');
export const fetchAdminGiftFeedImportHistory = (params = {}) => http.get('/admin/gift-feeds/import-history', { params });
export const triggerGiftFeedImport = (config = {}) => http.post('/gifts/feeds/import', {}, config);
export const searchAdminUsers = (params = {}) => http.get('/admin/users', { params });
export const fetchAdminUserDetail = (id) => http.get(`/admin/users/${id}`);
export const searchAdminFamilies = (query) => http.get('/admin/families', { params: { query } });
export const disableAdminUser = (userId) => http.post(`/admin/users/${userId}/disable`);
export const enableAdminUser = (userId) => http.post(`/admin/users/${userId}/enable`);
export const revokeAdminUserSessions = (userId) => http.post(`/admin/users/${userId}/revoke-sessions`);
export const setAdminUserTrial = (userId, action) => http.post(`/admin/users/${userId}/trial`, { action });
export const fetchAdminErrors = (params = {}) => http.get('/admin/errors', { params });
export const fetchAdminErrorOccurrences = (fingerprint) => http.get(`/admin/errors/fingerprint/${encodeURIComponent(fingerprint)}`);
export const resolveAdminErrorFingerprint = (fingerprint) => http.post(`/admin/errors/fingerprint/${encodeURIComponent(fingerprint)}/resolve`);
export const muteAdminErrorFingerprint = (fingerprint) => http.post(`/admin/errors/fingerprint/${encodeURIComponent(fingerprint)}/mute`);
export const fetchAdminAudit = (params = {}) => http.get('/admin/audit', { params });
export const fetchAdminAuditDetail = (id) => http.get(`/admin/audit/${id}`);
export const runTodayInFocusDryRun = (familyId) => http.post('/admin/today-in-focus/dry-run', { familyId });
export const fetchTodayInFocusRecent = () => http.get('/admin/today-in-focus/recent');
export const fetchTodayInFocusDetail = (id) => http.get(`/admin/today-in-focus/${id}`);
export const fetchTodayHealth = () => http.get('/admin/today/health');
export const fetchTodayTopics = (params = {}) => http.get('/admin/today/topics', { params });
export const createTodayTopic = (payload) => http.post('/admin/today/topics', payload);
export const reseedTodayTopics = () => http.post('/admin/today/seed');
export const updateTodayTopic = (topicId, payload) => http.patch(`/admin/today/topics/${topicId}`, payload);
export const deleteTodayTopic = (topicId) => http.delete(`/admin/today/topics/${topicId}`);
export const fetchTodayDecisions = (params = {}) => http.get('/admin/today/decisions', { params });
export const fetchTodayExposures = (params = {}) => http.get('/admin/today/exposures', { params });

export const fetchMilestoneDefinitions = (params = {}) => http.get('/admin/milestones', { params });
export const createMilestoneDefinition = (payload) => http.post('/admin/milestones', payload);
export const reseedMilestoneDefinitions = () => http.post('/admin/milestones/seed');
export const updateMilestoneDefinition = (milestoneId, payload) => http.patch(`/admin/milestones/${milestoneId}`, payload);
export const deleteMilestoneDefinition = (milestoneId) => http.delete(`/admin/milestones/${milestoneId}`);

export const fetchWorkflowTemplates = (params = {}) => http.get('/admin/workflows', { params });
export const createWorkflowTemplate = (payload) => http.post('/admin/workflows', payload);
export const reseedWorkflowTemplates = () => http.post('/admin/workflows/seed');
export const updateWorkflowTemplate = (templateId, payload) => http.patch(`/admin/workflows/${templateId}`, payload);
export const deleteWorkflowTemplate = (templateId) => http.delete(`/admin/workflows/${templateId}`);

export const fetchCatalogInsights = (params = {}) => http.get('/admin/insights', { params });
export const runCatalogInsightsRollup = () => http.post('/admin/insights/rollup');
export const draftCatalogInfo = (title) => http.post('/admin/assist/info', { title });

export const fetchOfficialSources = (params = {}) => http.get('/admin/sources', { params });
export const createOfficialSource = (payload) => http.post('/admin/sources', payload);
export const reseedOfficialSources = () => http.post('/admin/sources/seed');
export const updateOfficialSource = (sourceId, payload) => http.patch(`/admin/sources/${sourceId}`, payload);
export const deleteOfficialSource = (sourceId) => http.delete(`/admin/sources/${sourceId}`);

export const fetchAdminSlowRequests = () => http.get('/admin/slow-requests');
export const runAdminSmokeTest = () => http.post('/admin/smoke-test');

export const fetchAdminFeedback = () => http.get('/admin/feedback');
